import {
  FormSchemaDto,
  EditComponentErrorResponse,
  validate,
} from "@amzn/crowd-front-end-common-library";
import { useState, useEffect } from "react";
import { FormData } from "../types";

// Declare constant empty object to make reference comparisons constant.
const EMPTY_ERROR_OBJECT = Object.freeze({ errors: [] });

/**
 * Set validation state using currentValue and formSchema.
 *
 * @param {UseValidateFormSyncHookState} state
 */
function validateData(
  formSchema?: FormSchemaDto,
  currentValue?: FormData
): EditComponentErrorResponse {
  return formSchema && currentValue
    ? validate(currentValue, formSchema)
    : EMPTY_ERROR_OBJECT;
}

/**
 * React hook to synchronously validate a form.
 *
 * @template T
 * @param {FormSchemaDto} formSchema
 * @param {T} [currentValue]
 * @returns EditComponentErrorResponse
 */
function useValidateFormSync<T extends FormData>(
  formSchema?: FormSchemaDto,
  currentValue?: T
): EditComponentErrorResponse {
  const [validation, setValidation] = useState<EditComponentErrorResponse>(
    EMPTY_ERROR_OBJECT
  );

  useEffect(() => {
    setValidation(validateData(formSchema, currentValue));
  }, [formSchema, currentValue]);

  return validation;
}

export default useValidateFormSync;
